__turbopack_context__.v({
  "messageButton": "D_-Wta_messageButton",
});
